<template>
  <div class="vip_buy_warp">
    <van-overlay :show="show">
      <div class="vip_buy_box">
        <div class="vip_card">
          <svg-icon icon-class="vip_card"/>
        </div>
        <div class="info">
          <p>{{content}}</p>
          <p>{{vipText}}</p>
        </div>
        <div class="openVip" @click="toVip">立即开通</div>
        <div class="share" @click="$router.push('/promote')">分享推广</div>
        <div class="close" @click="$emit('close')">
          <svg-icon icon-class="close5"/>
        </div>
      </div>
    </van-overlay>
  </div>
</template>
<script>
import {Overlay} from "vant";

export default {
  props: {
    show: {
      type: Boolean,
      required: true,
      default: false,
    },
    content: {
      type: String,
      default: "需要会员权限才可以看哦～",
    },
    vipText: {
      type: String,
      default: "开通会员，无限观看",
    }
  },
  components: {
    [Overlay.name]: Overlay,
  },
  methods: {
    toVip() {
      this.$emit('setVipGrap');
      this.$router.push('/vipList');
    }
  }
}
</script>
<style lang="scss" scoped>
.vip_buy_warp {
  /deep/ .van-overlay {
    z-index: 9999;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .vip_buy_box {
    width: 340px;
    height: 320px;
    background: url('../../assets/png/vip_bg.png') no-repeat;
    background-size: cover;
    text-align: center;
    margin-bottom: 10%;
    position: relative;

    .vip_card {
      text-align: center;
      margin-top: -50px;

      > svg {
        font-size: 120px;
      }
    }

    .info {
      color: #425453;
      padding-top: 50px;
      text-align: center;
      line-height: 32px;
      font-size: 16px;

      p:nth-child(2) {
        color: #000000;

      }
    }

    .openVip {
      width: 252px;
      height: 38px;
      text-align: center;
      line-height: 38px;
      background: #ff9f19;
      border-radius: 6px;
      margin: 20px auto;
      font-size: 16px;
      box-shadow: 4px 4px 12px rgba(#ff7527, 0.5);

    }

    .share {
      font-size: 16px;
      text-align: center;
      color: #425453;
      display: inline-block;
      padding-top: 2px;
      padding-bottom: 4px;
      border-bottom: 0.5px solid rgba(#425453, 0.6);
    }

    .close {
      position: absolute;
      font-size: 32px;
      bottom: -60px;
      left: 50%;
      margin-left: -16px;
    }
  }

}
</style>
